<template>
    <div>
        <pagination
            v-model="computedModel"
            :records="totalRecords"
            :per-page="perPage"
            :options="{
                // edgeNavigation: true,
                template: markRaw(SearchSimplePagination),
            }"
        ></pagination>
    </div>
</template>
<script setup>
import Pagination from "v-pagination-3";
import { computed, markRaw } from "vue";
import { SearchSimplePagination } from "@/Components";

const props = defineProps([
    "clickHandler",
    "totalRecords",
    "currentPage",
    "perPage",
    "hideCount",
]);
const emits = defineEmits(["update:modelValue", "update:currentPage"]);

let computedModel = computed({
    // getter
    get() {
        return props.currentPage;
    },
    // setter
    set(newValue) {
        emits("update:currentPage", newValue);
    },
});
</script>

<style>
/* .VuePagination {} */
.pagination {
    @apply mb-4
    flex gap-x-1;
}

.pagination > .page-item > .page-link {
    @apply bg-gray-tier-5 hover:bg-gray-tier-6 disabled:bg-gray-tier-5
    border border-keyline-secondary
    font-medium
    h-8
    px-4
    rounded
    transition-colors;
}

.pagination > .page-item > .page-link.active {
    @apply bg-gray-tier-6;
}

.VuePagination__count {
    @apply font-medium text-sm;
}

.pagination > li > a,
.pagination > li > span {
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #337ab7;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid #ddd;
}

.pagination > li:first-child > a,
.pagination > li:first-child > span {
    margin-left: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.pagination > li:last-child > a,
.pagination > li:last-child > span {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.pagination > li > a:hover,
.pagination > li > span:hover,
.pagination > li > a:focus,
.pagination > li > span:focus {
    z-index: 3;
    color: #23527c;
    background-color: #eee;
    border-color: #ddd;
}

.pagination > .active > a,
.pagination > .active > span,
.pagination > .active > a:hover,
.pagination > .active > span:hover,
.pagination > .active > a:focus,
.pagination > .active > span:focus {
    z-index: 2;
    color: #fff;
    cursor: default;
    background-color: #337ab7;
    border-color: #337ab7;
}

.pagination > .disabled > span,
.pagination > .disabled > span:hover,
.pagination > .disabled > span:focus,
.pagination > .disabled > a,
.pagination > .disabled > a:hover,
.pagination > .disabled > a:focus {
    color: #777;
    cursor: not-allowed;
    background-color: #fff;
    border-color: #ddd;
}

.pagination-lg > li > a,
.pagination-lg > li > span {
    padding: 10px 16px;
    font-size: 18px;
    line-height: 1.3333333;
}

.pagination-lg > li:first-child > a,
.pagination-lg > li:first-child > span {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
}

.pagination-lg > li:last-child > a,
.pagination-lg > li:last-child > span {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
}

.pagination-sm > li > a,
.pagination-sm > li > span {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
}

.pagination-sm > li:first-child > a,
.pagination-sm > li:first-child > span {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}

.pagination-sm > li:last-child > a,
.pagination-sm > li:last-child > span {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}
</style>
